(function() { window.GUID_558571e6_059f_40e2_8cfb_8ac5b17da0a6 = { getGuid: function() { return "558571e6-059f-40e2-8cfb-8ac5b17da0a6"; } }; })();
var CompuSport;
(function (CompuSport) {
    var Controls;
    (function (Controls) {
        var Base;
        (function (Base) {
            class RefreshOnChange extends Base.BaseControl {
                constructor() {
                    super();
                }
                ExtractElementIdsFromData(dataContainer) {
                    var bind = dataContainer.data('bindelementids');
                    if (bind != null) {
                        this.BindElementIds = bind.split(',');
                    }
                    var refresh = dataContainer.data('refreshelementids');
                    if (refresh != null) {
                        this.RefreshElementIds = refresh.split(',');
                    }
                }
                RefreshOnElementValueChange(callback) {
                    //Ici, je m'abonne à l'event Change des controles passé dans RefreshElementIds
                    var me = this;
                    if (me.RefreshElementIds != undefined) {
                        var lastIndex = me.RefreshElementIds.length - 1;
                        if (me.RefreshElementIds != null && me.RefreshElementIds[0] != "") {
                            $.each(me.RefreshElementIds, function (index, id) {
                                var control = $('#' + id);
                                if (control.length == 0) {
                                    control = $('[name="' + id + '"]');
                                }
                                var eventWithNamespace = 'change.' + me.Id;
                                control.off(eventWithNamespace);
                                control.on(eventWithNamespace, function () {
                                    callback.call(this);
                                });
                            });
                        }
                    }
                }
            }
            Base.RefreshOnChange = RefreshOnChange;
        })(Base = Controls.Base || (Controls.Base = {}));
    })(Controls = CompuSport.Controls || (CompuSport.Controls = {}));
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=RefreshOnChange.js.map
